import React, {useEffect, useState, useRef} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import { useMemo } from 'react'
import { Iconfont } from '../../../../components/icon/iconfont'
import MeLoading from '../../components/loading'
import { FormattedMessage, useIntl } from 'react-intl'
import fecha from 'fecha'
import Header from "../../../policy/fragments/heading/index"
import { makeSuggestion } from '../../../../../api'
import { BigButton } from '../../../../components/button'
import _ from 'lodash'
import Toast from '../../../../components/toast'
import Mask from '../../../../components/alert/mask'
import { useHistory } from 'react-router-dom'
import Compressor from 'compressorjs'


const TypeChoose = props => {
    useStyles(classes)
    const {typeList, showRequired, selected, typeChange, otherChange} = props
    const [showList, setShowList] = useState(false)

    const selectedLabel = useMemo(() => {
        let typeSelect = typeList?.find(t => t.value == selected) || typeList?.[0] || {}
        return typeSelect?.title || ''
    }, [selected, typeList])

    return (
        <div className={classes.TypeChoose}>
            <div className={classes.Title}>
                <span className={classes.Required}>*</span>
                <span><FormattedMessage id="question_type" defaultMessage={'Question Type'}/> </span>
            </div>
            <div className={`${showRequired && !selected ? classes.BorderRed: ''}`}>
                <div className={`${classes.SelectBox}`}>
                    <div className={classes.Container} onClick={() => setShowList(!showList)}>
                        <div className={classes.SelectValue}>{selectedLabel}</div>
                        <div className={`${classes.IconBox}`}>
                            <Iconfont className={`${classes.SelectIcon} ${showList ? classes.IconActive: ''}`}>&#xe695;</Iconfont>
                        </div>
                    </div>
                </div>
                <div className={`${classes.ListBox} ${showList ? classes.ListShow: classes.ListHide}`}>
                    <ul>
                        {
                            typeList?.map((item, index) => {
                                return <li className={`${selected == item?.value ? classes.ListActive: ''}`} onClick={() => typeChange(item)}>
                                    <input type="radio" id={"question"+index} name={item?.value} value={item?.value} />
                                    <label for={"question"+index}></label>
                                    <span>{item?.title}</span>
                                </li>
                            })
                        }
                    </ul>
                </div>

                {
                    selected == 'Other error' ?
                    <div className={classes.OtherInput}>
                        <textarea maxLength="150" name="Other error" onChange={(e) => otherChange(e?.target?.value)}></textarea>
                    </div>:
                    <React.Fragment></React.Fragment>
                }
            </div>
        </div>
    )
}

const TimeSelect = props => {
    useStyles(classes)
    const {showRequired, dateValue, dateChange} = props

    return (
        <div className={classes.TimeSelect}>
            <div className={classes.TimeBox}>
                <div className={classes.Title}>
                    <span className={classes.Required}>*</span>
                    <span><FormattedMessage id="time" defaultMessage={'Time'}/></span>
                </div>
                <div className={`${showRequired ? classes.BorderRed: ''}`} style={{position:'relative'}}>
                    <div className={classes.TimeFlex}>
                        <div className={classes.TimeValue}>
                            {dateValue}
                        </div>
                        <div>
                            <label htmlFor="suggestionDatePicker">
                                <Iconfont className={classes.TimeIcon}>&#xe694;</Iconfont>
                            </label>
                        </div>
                    </div>
                    <input type="date" id="suggestionDatePicker" onChange={e => dateChange(e)}/>
                </div>
            </div>
        </div>
    )
}

const DescriptionInput = props => {
    useStyles(classes)
    const {descriptionValue, descriptionChange, showRequired} = props
    const Intl = useIntl()

    const descriptionNum = useMemo(() => {
        if(!descriptionValue){
            return 0
        } else {
            return 1000 - (descriptionValue?.length || 0)
    }
    }, [descriptionValue])

    return (
        <div className={classes.DescriptionInput}>
            <div className={classes.Title}>
                <span className={classes.Required}>*</span>
                <span><FormattedMessage id="description" defaultMessage={'Description'}/></span>
            </div>

            <div className={`${showRequired ? classes.BorderRed: ''} ${classes.DesInputBox}`}>
                <textarea
                    maxLength="1000"
                    name="description"
                    placeholder={Intl.formatMessage({id: 'suggestion_placeholder',defaultMessage:'Sorry for the inconvenience, we will fix the problem as soon as possible…'})}
                    onChange={e => descriptionChange(e)}>
                </textarea>
            </div>

            <p className={classes.DescriptionNum}>{descriptionNum}/1000</p>
        </div>
    )
}

const UploadImage = props => {
    useStyles(classes)
    const {uploadedImages, uploadedImagesChange, uploadedFilesChange} = props
    const imageLoader = useRef()
    const [imageFiles, setImageFiles] = useState([])
    const [imageUrls, setImageUrls] = useState([])

    const loadImg = (e) => {
        let files = e?.target?.files
        let imgFiles = [...imageFiles]
        let list = [...imageUrls]
        if(!files)return
        imgFiles = imgFiles.concat(files)
        _.each(files, file => {
            let src = window.navigator.userAgent.indexOf("Chrome") >=1 ||
                      window.navigator.userAgent.indexOf("Safari") >=1 ?
                      window.webkitURL.createObjectURL(file):
                      window.URL.createObjectURL(file)
            list.push(src)
        })
        if(list?.length > 3){
            list.splice(3, list?.length - 3)
            imgFiles.splice(3, imgFiles?.length - 3)
        }
        setImageUrls(list)
        setImageFiles(imgFiles)
        uploadedImagesChange(list)
        uploadedFilesChange(imgFiles)
    }

    const removeImg = (index) => {
        let files = [...imageFiles]
        let urls = [...imageUrls]
        files.splice(index, 1)
        urls.splice(index, 1)
        setImageFiles(files)
        setImageUrls(urls)
        uploadedImagesChange(urls)
        uploadedFilesChange(files)
    }

    return (
        <div className={classes.UploadImage}>
            <div className={classes.Title}>
                <span><FormattedMessage id="upload_image" defaultMessage={'Upload Image'}/></span>
                <p><FormattedMessage id="image_formate" defaultMessage={'Maximum of 3 photos, only JPEG, GIF or PNG.'}/></p>
            </div>
            <div className={classes.UploadImageBox}>
                <div className={`${classes.UploadContainer}`}>
                    {
                        uploadedImages?.length > 0 ?
                        <React.Fragment>
                            <ul>
                                {
                                    uploadedImages?.map((item, index) => {
                                        return <li className={classes.Image} key={index + item}>
                                            <img src={item} alt="" />
                                            <span className={classes.RemoveImg} onClick={() => removeImg(index)}>&times;</span>
                                        </li>
                                    })
                                }
                            </ul>
                        </React.Fragment>:
                        <React.Fragment></React.Fragment>
                    }
                    {
                        !uploadedImages || uploadedImages?.length < 3 ?
                        <React.Fragment>
                            <div className={classes.ImageItem}>
                                <form ref={imageLoader}>
                                    <input
                                        type="file"
                                        name="imageFiles"
                                        multiple="multiple"
                                        onChange={(e) => loadImg(e)}
                                        accept="image/jpg,image/jpeg,image/png,image/gif"/>
                                </form>
                                <Iconfont className={classes.AddBtn}>&#xe6d3;</Iconfont>
                            </div>
                        </React.Fragment>:
                        <React.Fragment></React.Fragment>
                    }
                </div>
            </div>
        </div>
    )
}

const ReminderModal = props => {
    useStyles(classes)
    const {reminderMessage, onClose} = props
    const history = useHistory()

    return (
        <React.Fragment>
            <div className={classes.ModalContainer}>
                <div className={classes.Container}>
                    <div dangerouslySetInnerHTML={{__html: reminderMessage}}></div>

                    <BigButton className={classes.ModalBtn} onClick={() => window.location.href = '/'}>
                        <FormattedMessage id={'shop_now'} defaultMessage={'Shop Now'}/>
                    </BigButton>

                    <BigButton className={classes.ModalBtn} onClick={() => history.push('/user/credits')}>
                        <FormattedMessage id={'get_more_points'} defaultMessage={'Get More Points'}/>
                    </BigButton>
                </div>
            </div>
            <Mask onClick={() => onClose()}/>
        </React.Fragment>
    )
}

const MakeSuggestionPage = props => {
    useStyles(classes)

    const [loading, setLoading] = useState(false)
    const [typeSelect, setTypeSelect] = useState()
    const [typeOtherInput, setTypeOtherInput] = useState('')
    const [dateValue, setDateValue] = useState()
    const [descriptionValue, setDescriptionValue]= useState('')
    const [uploadedImages, setUploadImages] = useState()
    const [requiredObj, setRequiredObj] = useState({type: false, time:false, description:false})
    const [uploadFiles, setUploadFiles] = useState()
    const [reminderMessage, setReminderMessage] = useState('')

    const Intl = useIntl()

    const typeList = [
        {
            id: 0,
            title: Intl.formatMessage({id: 'screen_freeze', defaultMessage:'Screen Freeze'}),
            value: 'Screen Freeze'
        },
        {
            id: 1,
            title: Intl.formatMessage({id: 'app_crush', defaultMessage:'App crush'}),
            value: 'App crush'
        },
        {
            id: 2,
            title: Intl.formatMessage({id: 'black_screen', defaultMessage:'Black Screen'}),
            value: 'Black Screen'
        },
        {
            id: 3,
            title: Intl.formatMessage({id: 'device_reboot', defaultMessage:'Device reboot'}),
            value: 'Device reboot'
        },
        {
            id: 4,
            title: Intl.formatMessage({id: 'running_slowly', defaultMessage:'Running slowly'}),
            value: 'Running slowly'
        },
        {
            id: 5,
            title: Intl.formatMessage({id: 'other_error', defaultMessage:'Other error'}),
            value: 'Other error'
        },
    ]

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }, [])

    const dateValueFormate = useMemo(() => {
        if(dateValue?.length > 0){
            var d = new Date(Date.parse(dateValue.replace(/-/g,"/")));
            var curDate = new Date();
            if(d >= curDate){
                alert(Intl.formatMessage({id: 'time_must_current', defaultMessage: 'Date of birth must be less than the current time!'}))
                return fecha.format(new Date(), 'YYYY/MM/DD')
            }else{
                return fecha.format(new Date(dateValue), 'YYYY/MM/DD')
            }
        }else{
           return '';
        }
    }, [dateValue])

    const submitHandle = () => {
        let formData = new FormData();
        if(uploadFiles){
            let imgFileList = []
            let fileSize = 0
            uploadFiles?.forEach(imgList => {
                for(let i = 0; i < imgList?.length; i++){
                    if (imgList[i]?.type?.indexOf('gif') != -1) {
                        fileSize += imgList[i]?.size || 0
                        imgFileList.push(imgList[i])
                    } else {
                        fileSize += imgList[i]?.size || 0
                        imgFileList.push(compressorImage(imgList[i]))
                    }
                }
            })
            if(fileSize > 2048000){
                Toast(Intl.formatMessage({id:'upload_file_size_limit',defaultMessage:"File size must under 2MB"}))
                return
            }
            // return
            Promise.all(imgFileList).then(results => {
                results?.forEach(item => {
                    const { file } = item
                    if (file) {
                        formData.append('imageFiles', new File([file], file?.name))
                    } else {
                        formData.append('imageFiles', new File([item], item?.name))
                    }
                })
                submitFunc(formData)
            })
        } else {
            submitFunc(formData)
        }
    }

    const submitFunc = async (formData) => {
        if(!typeSelect){
            setRequiredObj({...requiredObj, type:true})
            return
        } else if(typeSelect == 'Other error'){
            if(!typeOtherInput){
                setRequiredObj({...requiredObj, type:true})
                return
            } else {
                setRequiredObj({...requiredObj, type:false})
                formData.append("label", typeOtherInput)
            }
        } else {
            setRequiredObj({...requiredObj, type:false})
            formData.append("label", typeSelect)
        }

        if(!dateValueFormate){
            setRequiredObj({...requiredObj, time:true})
            return
        } else {
            setRequiredObj({...requiredObj, time: false})
            formData.append("time", dateValueFormate)
        }

        if(!descriptionValue){
            setRequiredObj({...requiredObj, description:true})
            return
        } else {
            setRequiredObj({...requiredObj, description: false})
            formData.append("message", descriptionValue)
        }
        setLoading(true)
        const response  = await makeSuggestion(formData, {"Content-Type": 'multipart/form-data'})
        setLoading(false)
        if(response?.code == 200){
            const {prompt} = response
            if(prompt?.html){
                // 积分弹窗提示
                setReminderMessage(prompt?.html)
            } else {
                Toast(Intl.formatMessage({id: 'update_success', defaultMessage: 'Update Success'}))
            }
        } else {
            alert(response?.result || response)
        }
    }

    const compressorImage = (image, backType, quality) => {
        return new Promise((resolve, reject) => {
            new Compressor(image, {
                quality: quality || 0.6,
                success(result){
                    const file = new File([result], image?.name, {type: image?.type});
                    if(!backType || backType == 'blob'){
                        resolve(result)
                    } else if (backType == 'file'){
                        resolve(file)
                    } else {
                        resolve(file)
                    }
                },
                error(err){
                    reject(err)
                }
            })
        })
    }


    return <div classes={classes.SuggestionPage}>
        <Header centerSlot={Intl.formatMessage({id: 'suggestion', defaultMessage: 'Suggestion'})} />

        <TypeChoose
            typeList={typeList}
            showRequired={requiredObj?.type}
            selected={typeSelect}
            typeChange={(item) => setTypeSelect(item?.value)}
            otherChange={value => setTypeOtherInput(value)}
            />

        <TimeSelect
            showRequired={requiredObj?.time}
            dateValue={dateValueFormate}
            dateChange={e => setDateValue(e?.target?.value)}
            />

        <DescriptionInput
            showRequired={requiredObj?.description}
            descriptionValue={descriptionValue}
            descriptionChange={e => setDescriptionValue(e?.target?.value)}
            />

        <UploadImage
            uploadedImages={uploadedImages}
            uploadedImagesChange={e => setUploadImages(e)}
            uploadedFilesChange={file => setUploadFiles(file)}
            />

        {
            reminderMessage ?
            <ReminderModal
                reminderMessage={reminderMessage} onClose={() => setReminderMessage('')}/>:
            <React.Fragment></React.Fragment>
        }

        <div className={classes.SignOutButton}>
            <BigButton onClick={submitHandle}><FormattedMessage id="submit" defaultMessage="Submit"/></BigButton>
        </div>

        <MeLoading loading={loading} />
    </div>
}

MakeSuggestionPage.fetchData = async (store, params, search, headers) => {
    // await store.dispatch(action_fetch_message('M1545',headers))
}

export default MakeSuggestionPage